import React from 'react'
import ReactMarkdown from 'react-markdown'
import classNames from 'classnames'
import { Section } from '../../../../index'

const Perks = props => {
  const {
    content: { markdown, images, metadata },
  } = props
  return (
    <Section
      className={classNames('perks', metadata ? metadata.className : '')}
      innerClassName="intro__wrapper"
      isCentered
    >
      <section className="perks__images">
        <div className="perks__left">
          {images.map(({ id, title, sizes }) => (
            <img
              key={id}
              className="perks__image"
              src={sizes.src}
              srcSet={sizes.srcSet.split('fm=jpg').join('fm=jpg&fl=progressive')}
              sizes="50vw"
              alt={title}
            />
          ))}
        </div>
      </section>
      <section className="perks__markdown">
        <ReactMarkdown escapeHtml={false} source={markdown.content} />
      </section>
      <hr />
    </Section>
  )
}

export default Perks
